"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conflict = void 0;
const ResponseError_1 = require("./ResponseError");
class Conflict extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || Conflict.label;
        this.type = Conflict.type;
        this.statusCode = Conflict.statusCode;
        Error.captureStackTrace(this, Conflict);
    }
}
exports.Conflict = Conflict;
Conflict.type = 'Conflict';
Conflict.label = 'Conflict';
Conflict.statusCode = 409;
//# sourceMappingURL=Conflict.js.map